import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { ALLOWED_FILE_TYPES } from '@/constants'
import { useUpdateDealUploadedFiles } from '@/domains/deals/hooks'
import { useMutationShowingErrors } from '@/hooks'
import SectionTitle from '@/redesign/components/SectionTitle/SectionTitle'
import { UppyUploader } from '@/redesign/components/UppyUploader/UppyUploader'
import { Deal, ERoles } from '@/schemaTypes'
import { useHasMinRole } from '@/utils/roles'

export interface UploadDealOverviewProps {
  deal: Deal
}

const UploadDealOverview = (props: UploadDealOverviewProps) => {
  const { deal } = props
  const { t } = useTranslation()
  // Stored documents are kept for traceability; only admins remove them.
  const canRemoveDocuments = useHasMinRole(ERoles.Admin)

  const updateDealUploadedFiles = useMutationShowingErrors({
    mutation: useUpdateDealUploadedFiles(),
  })

  const handleUploadOverview = async (files) => {
    await updateDealUploadedFiles({
      variables: {
        dealId: deal._id,
        uploadedFilesArgs: extractPropertiesFromArray(files || []),
      },
    })
  }

  return (
    <Formik
      initialValues={{ ...deal }}
      onSubmit={() => {
        //
      }}
    >
      {() => {
        return (
          <Form>
            <div>
              <SectionTitle title={t('uploads_overview')} />
              <UppyUploader
                canRemoveStoredFiles={canRemoveDocuments}
                onFileChanged={handleUploadOverview}
                confirmPopupBeforeRemove
                allowedFileTypes={[...ALLOWED_FILE_TYPES, '.pdf']}
                multiple
                name="uploadedFiles"
              />
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}

const extractPropertiesFromArray = (arr: any[]) => {
  return arr.map(({ id, ...rest }) => rest)
}

export default UploadDealOverview
